module.exports = __webpack_public_path__ + "static/media/arrow-alt-down.47ec437a.svg";